import axios from "axios";
import "./request_interceptor";


//const end_point1 = "http://192.168.30.225:88/api/stock_service/";
//const end_point1 = "https://preprodb.portailachats.ma/api/stock_service/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/assets_service/";

////////////////////////////////////////////////////
////
////////////////////////////////////////////////////

export const get_fixed_assets = async (params = {}) => {
  return await axios.get(end_point1 + "get_fixed_assets", { params });
};

export const add_fixed_assets = async (data) => {
  return await axios.post(end_point1 + "add_fixed_assets", data);
};

export const get_fixed_asset_by_id = async (id) => {
  return await axios.get(end_point1 + "get_fixed_asset_by_id/" + id);
};

export const update_fixed_asset = async (id, data) => {
  return await axios.put(end_point1 + "update_fixed_asset/" + id, data);
};

export const delete_fixed_asset = async (id) => {
  return await axios.delete(end_point1 + "delete_fixed_asset/" + id);
};

export const markAsExported = async (data) => {
  return await axios.post(end_point1 + "markAsExported", data);
};